/* eslint-disable @typescript-eslint/no-explicit-any */
import { isPlatformBrowser } from '@angular/common';
import { Injectable, PLATFORM_ID, inject } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class OfflineService {
  readonly platformId = inject(PLATFORM_ID);

  private serviceWorkerRegistration: ServiceWorkerRegistration;

  private offlineSubjects = new Map<string, Subject<any>>();

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);

  constructor() {
    const platformId = this.platformId;

    if (isPlatformBrowser(platformId)) {
      // eslint-disable-next-line
      if (navigator.serviceWorker) {
        const messageChannel = new MessageChannel();
        // navigator.serviceWorker.register('sw-master.js');
        // eslint-disable-next-line
        navigator.serviceWorker.addEventListener('message', (event) => {
          // event is a MessageEvent object
          if (event.data.customerId && event.data.locationId && event.data.identifier) {
            const key = `${event.data.customerId}_${event.data.locationId}_${event.data.identifier}`;

            if (!this.offlineSubjects.has(key)) {
              this.offlineSubjects.set(key, new Subject<any>());
            }
            const subject = this.offlineSubjects.get(key);
            subject.next(event.data);
          }
        });
        // eslint-disable-next-line
        navigator.serviceWorker.ready.then((registration) => {
          this.serviceWorkerRegistration = registration;

          registration.active.postMessage(
            {
              type: 'INIT_PORT',
            },
            [messageChannel.port2],
          );

          // Listen to the response
          messageChannel.port1.onmessage = (event) => {
            // Print the result
            const key = `${event.data.customerId}_${event.data.locationId}_${event.data.identifier}`;

            if (!this.offlineSubjects.has(key)) {
              this.offlineSubjects.set(key, new Subject<any>());
            }
            const subject = this.offlineSubjects.get(key);
            subject.next(event.data);
          };
        });
      }
    }
  }

  public dispatchGetOfflineData(
    customerId: number,
    locationId: number,
    identifier: string,
  ): boolean {
    if (this.serviceWorkerRegistration?.active) {
      this.serviceWorkerRegistration.active.postMessage({
        type: 'RETRIEVE_OFFLINE_DATA',
        customerId,
        locationId,
        identifier,
      });
      return true;
    }
    return false;
  }

  public dispatchDeleteOfflineData(
    customerId: number,
    locationId: number,
    identifier: string,
  ): boolean {
    if (this.serviceWorkerRegistration?.active) {
      this.serviceWorkerRegistration.active.postMessage({
        type: 'DELETE_OFFLINE_DATA',
        customerId,
        locationId,
        identifier,
      });
      return true;
    }
    return false;
  }

  public getOfflineDataObservable$(
    customerId: number,
    locationId: number,
    identifier: string,
  ): Observable<any> {
    const key = `${customerId}_${locationId}_${identifier}`;
    if (!this.offlineSubjects.has(key)) {
      this.offlineSubjects.set(key, new Subject<any>());
    }
    const subject = this.offlineSubjects.get(key);
    return subject.asObservable();
  }
}
